import { render, staticRenderFns } from "./TheFavorites.vue?vue&type=template&id=b23cce46&scoped=true&"
import script from "./TheFavorites.vue?vue&type=script&lang=ts&"
export * from "./TheFavorites.vue?vue&type=script&lang=ts&"
import style0 from "./TheFavorites.vue?vue&type=style&index=0&id=b23cce46&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23cce46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsTooltip: require('/app/src/components/common/EsTooltip.vue').default,EsPopover: require('/app/src/components/common/EsPopover.vue').default})
